export default {
  'user-register-result.login.userName': '賬戶',
  'user-register-result.login.password': '密碼',
  'user-register-result.login.message-invalid-credentials': '賬戶或密碼錯誤（admin/ant.design）',
  'user-register-result.login.message-invalid-verification-code': '驗證碼錯誤',
  'user-register-result.login.tab-login-credentials': '賬戶密碼登錄',
  'user-register-result.login.tab-login-mobile': '手機號登錄',
  'user-register-result.login.remember-me': '自動登錄',
  'user-register-result.login.forgot-password': '忘記密碼',
  'user-register-result.login.sign-in-with': '其他登錄方式',
  'user-register-result.login.signup': '註冊賬戶',
  'user-register-result.login.login': '登錄',
  'user-register-result.register.register': '註冊',
  'user-register-result.register.get-verification-code': '獲取驗證碼',
  'user-register-result.register.sign-in': '使用已有賬戶登錄',
  'user-register-result.register-result.msg': '妳的賬戶：{email} 註冊成功',
  'user-register-result.register-result.activation-email':
    '激活郵件已發送到妳的郵箱中，郵件有效期為24小時。請及時登錄郵箱，點擊郵件中的鏈接激活帳戶。',
  'user-register-result.register-result.back-home': '返回首頁',
  'user-register-result.register-result.view-mailbox': '查看郵箱',
  'user-register-result.navBar.lang': '語言',
};
